"use strict";
/**
 * @class Dynamic Select
 * @description Displays a list of options which are retrieved asynchronously
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../../../codegen/Messages");
var Select_1 = require("./Select");
var formContextHOC_1 = require("./formContextHOC");
// Default argument validation function. Usually we just want to make sure that the arguments exist
function defaultValidateLoadArgs() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i += 1) {
        if (typeof args[i] === "undefined" ||
            (typeof args[i] === "string" && args[i].length === 0)) {
            return false;
        }
    }
    return true;
}
/**
 * OUI dynamic select component.
 *
 * @oui-component DynamicSelect
 */
var DynamicSelectInternal = /** @class */ (function (_super) {
    __extends(DynamicSelectInternal, _super);
    function DynamicSelectInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            options: [],
            disabled: false,
            isPopulated: false,
            isLoading: false
        };
        return _this;
    }
    /**
     * Load select menu options and handle the following states
     * 1) Loading
     * 2) Options loaded and present
     * 3) Options loaded but empty
     * 4) Error loading options
     * @param loadArgs Arguments to validate and pass into load function
     */
    DynamicSelectInternal.prototype.load = function (loadArgs) {
        if (loadArgs === void 0) { loadArgs = []; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, fieldName, validateLoadArgs, needsArgsText, load, loadingText, emptyText, placeholder, errorText, form, lastValue, validate, loadingMessage, options, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, fieldName = _a.fieldName, validateLoadArgs = _a.validateLoadArgs, needsArgsText = _a.needsArgsText, load = _a.load, loadingText = _a.loadingText, emptyText = _a.emptyText, placeholder = _a.placeholder, errorText = _a.errorText, form = _a.form;
                        lastValue = form ? form.getValue(fieldName) : undefined;
                        validate = validateLoadArgs || defaultValidateLoadArgs;
                        if (!validate.apply(void 0, __spread(loadArgs))) {
                            this.noOptionsAvailable(needsArgsText || "");
                            return [2 /*return*/, Promise.resolve([])];
                        }
                        loadingMessage = Messages.Common.loading();
                        this.setState({
                            options: [
                                {
                                    label: loadingText || loadingMessage,
                                    value: lastValue || loadingMessage
                                }
                            ],
                            disabled: true,
                            isLoading: true
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, load.apply(void 0, __spread(loadArgs))];
                    case 2:
                        options = _b.sent();
                        if (options.length === 0) {
                            this.noOptionsAvailable(emptyText || Messages.DynamicSelect.defaultEmptyText());
                        }
                        else {
                            placeholder &&
                                options.unshift({ label: placeholder, value: "", disabled: true });
                            this.setState({ options: options, disabled: false, isPopulated: true, isLoading: false });
                            if (lastValue) {
                                if (Select_1.findOption(options, lastValue)) {
                                    form && form.setValue(fieldName, lastValue, true);
                                }
                            }
                            else {
                                form && form.setValue(fieldName, Select_1.findFirstValue(options), false);
                            }
                        }
                        return [2 /*return*/, options];
                    case 3:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.noOptionsAvailable(errorText || Messages.DynamicSelect.defaultError());
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DynamicSelectInternal.prototype.noOptionsAvailable = function (reason) {
        var _a = this.props, fieldName = _a.fieldName, form = _a.form;
        this.setState({
            options: [{ label: reason, value: "", disabled: true }],
            disabled: true,
            isLoading: false
        });
        form && form.setValue(fieldName, undefined, true);
    };
    DynamicSelectInternal.prototype.componentDidMount = function () {
        this.load(this.props.loadArgs);
    };
    // If props have changed, reload options
    DynamicSelectInternal.prototype.componentWillReceiveProps = function (newProps) {
        if (JSON.stringify(newProps.loadArgs) !== JSON.stringify(this.props.loadArgs)) {
            this.load(newProps.loadArgs);
        }
    };
    DynamicSelectInternal.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder, focusable = _a.focusable, fieldName = _a.fieldName, testId = _a.testId, label = _a.label, labelledBy = _a.labelledBy;
        var _b = this.state, options = _b.options, disabled = _b.disabled, isPopulated = _b.isPopulated, isLoading = _b.isLoading;
        var selectProps = {
            label: label,
            labelledBy: labelledBy,
            focusable: focusable,
            onChange: onChange,
            value: value,
            placeholder: placeholder,
            fieldName: fieldName,
            testId: testId,
            disabled: disabled,
            busy: isLoading
        };
        return (React.createElement(Select_1.default, __assign({}, selectProps, { options: options }, { placeholder: isPopulated ? placeholder : undefined })));
    };
    return DynamicSelectInternal;
}(React.Component));
var DynamicSelect = function (props) { return (React.createElement(DynamicSelectInternal, __assign({}, props))); };
exports.default = formContextHOC_1.default(DynamicSelect);
//# sourceMappingURL=DynamicSelect.js.map